import React from "react";
import { Table, Button, Popover, Input, Label, Progress } from "reactstrap";
import Row from "../Row";
import { DisplayMoreRow } from "../DisplayMoreRow";
import DropZoneTable from "./DropZoneTable";
import { connect } from "react-redux";
import { bool } from "prop-types";
import UpArrow from '@mui/icons-material/KeyboardArrowUp';
import DownArrow from '@mui/icons-material/KeyboardArrowDown';

class SmtpConfigTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 0,
      numPages: 0,
      pageNumber: 1,
      prevPageLimit: 0,
      pageLimit: 100,
      rowsShown: 9,
      refPopoverOpen: false,
      statusPopoverOpen: false,
      importPopoverOpen: false,
      actionPopoverOpen: false,
      datePopoverOpen: false,
      loading: false,
      jumpToPopoverOpen: false,
      textPageNumber: 0,
      fromDate: "",
      toDate: "",
      display_all_assoc: false,
      sortConfig: { key: null, direction: 'asc' },
      ...props,
      emailConfig: '',
      filters: {
        emailConfig: '',
        type: '',
        host: '',
        folder: '',
        port: '',
        isDefault: ''
      },
      showFilters: false
    };
  }

  onRowClicked = (row) => {
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });
  }

  componentDidUpdate(prevProps, prevState) {
      if (prevProps.logs !== this.props.logs) {
      const noPages = Math.ceil(this.props.logs.length / this.state.pageLimit);
      this.setState({
        logs: this.props.logs,
        numPages: noPages,
        currentPage: 0,
        loading: false
      });
    }
    if (
      this.state.currentPage !== prevState.currentPage ||
      this.state.numPages !== prevState.numPages
    ) {
      this.setState({
        textPageNumber: this.state.currentPage + 1,
      });
    }

    if (this.state.textPageNumber !== prevState.textPageNumber) {
      this.setState({
        currentPage: this.state.textPageNumber - 1,
      });
    }
  }

  handleFilterChange = (key, value) => {
    this.setState((prevState) => ({
        filters: {
            ...prevState.filters,
            [key]: value
        },
        currentPage: 0 // optional: reset to first page on filter
        }));
    };

    toggleFilters = () => {
        this.setState((prevState) => ({
            showFilters: !prevState.showFilters
        }));
    };
    
    clearAllFilters = () => {
        this.setState({
            filters: {
              emailConfig: '',
              type: '',
              host: '',
              folder: '',
              port: '',
              isDefault: ''
            },
            currentPage: 0 // optional: reset to first page
        });
    };

  toggle(id) {
    let popoverid = id + "PopoverOpen";
    this.setState({
      [popoverid]: !this.state[popoverid],
    });
  }

  onSort = (key) => {
        this.setState((prevState) => {
            const direction = prevState.sortConfig.key === key && prevState.sortConfig.direction === 'asc' ? 'desc' : 'asc';

            const logs = prevState.logs ?? this.props.logs;

            const sortedRows = [...logs].sort((a, b) => {
                let aValue = a[key];
                let bValue = b[key];

                // Fallback in case of undefined values
                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';

                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();

                if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            return {
                logs: sortedRows,
                sortConfig: { key, direction }
            };
        });
    };

     renderSortableFilterableHeader = (filterKey, label) => {
      const isSorted = this.state.sortConfig.key === filterKey;
      const sortArrow = isSorted
      ? this.state.sortConfig.direction === 'asc'
        ? <UpArrow />
        : <DownArrow />
      : null;

      return (
      <th
        key={filterKey}
        className="s-grid-title-cell"
        style={{ cursor: 'pointer' }}
        onClick={() => this.onSort(filterKey)}
      >
        <div className="s-grid-title-cell-filter">
          {label} {sortArrow}
        </div>
        <div>
          {this.state.showFilters && (
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder="Start typing to search..."
              value={this.state.filters[filterKey] || ''}
              onMouseDown={(e) => e.stopPropagation()}
              onChange={(e) => this.handleFilterChange(filterKey, e.target.value)}
            />
          )}
        </div>
      </th>
      );
    };

    getLocalizedLabel = (key, fallback) => {
      const labelObj = this.props.userReducer.localisation[key];
      return labelObj?.element_lang || fallback;
    };


  render() {
    
    var b = true;
    let grid_css;
    let id;
    let rows = [];
    let pagination = <div />;
    let is_checked = false;
    let progress;

    const { localisation } = this.props.userReducer;

    const filtersActive = Object.values(this.state.filters).some(
            val => val.trim() !== ''
    );

    let startItem = (this.state.currentPage * this.state.rowsShown) + this.state.currentPage;

    let endItem = startItem + this.state.rowsShown;

    let logsToRender = (this.state.logs?.length ? this.state.logs : this.props.logs).filter(file => {
            const { filters } = this.state;

            const matches = (field, value) => {
              if (!value.trim()) return true; // if no filter applied, always match
              return (field ?? '').toString().toLowerCase().includes(value.toLowerCase());
            };

            return (
                matches(file.emailConfig, filters.emailConfig) &&
                matches(file.type, filters.type) &&
                matches(file.host, filters.host) && 
                matches(file.folder, filters.folder) &&
                matches(file.port, filters.port) &&
                matches(file.isDefault, filters.isDefault)
            );
    });

    if (logsToRender) {
      logsToRender.forEach((row, i) => {
        if (!this.props.nopages) {
          if (i < startItem)
              return
          if (i > endItem)
              return
        }

        const configNameProperty = row.emailConfig === null 
        || row.emailConfig === undefined 
        || row.emailConfig === "" 
        ? "Not applicable" 
        : row.emailConfig;

        if (b)
            grid_css = "s-grid-row"
        else
            grid_css = "s-grid-row s-record-alt"
        b = !b

        id = "P" + row._id

        rows.push(
        <Row
          rightAlign={[5]}
          smtpconfigpopover
          onRowClicked={this.onRowClicked}
          is_checked={is_checked}
          checked={this.props.checked}
          i={i}
          checkChange={this.props.checkChange}
          refresh={this.props.refresh}
          id={id}
          fileid={this.props.id}
          tr_css={grid_css}
          filename={row.type}
          filetype={row.host}
          emailConfig={configNameProperty}
          version={row.folder}
          user={row.port}
          file={row}
          pages={1}
          isDefault={row.isDefault}
          columnConfig={this.props.columnConfig}
        />
      );

      });
    }

    if (this.props.loading)
      progress = <Progress color="info" animated value={100} />;
    else progress = <div />;

    if (this.props.logs){
      pagination = <div>
        <div class="s-array-topbar-right">
          <label class="s-pager-range">
              {this.props.logs.length > 1
                ? localisation['table_header_records']
                  ? this.props.logs.length +
                    ' ' +
                    localisation['table_header_records'].element_lang
                  : this.props.logs.length + ' Records'
                : localisation['table_header_record']
                ? this.props.logs.length +
                  ' ' +
                  localisation['table_header_record'].element_lang
                : this.props.logs.length + ' Record'}
          </label>
          <button
                className="btn btn-sm btn-outline-secondary"
                style={{ marginLeft: '10px' }}
                onClick={this.toggleFilters}
                title={this.state.showFilters ? 'Hide search filters' : 'Show search filters'}
            >
                <i className="fa fa-filter" aria-hidden="true"></i>
                <span style={{ marginLeft: '5px' }}>
                {this.state.showFilters ? 'Hide search Filters' : 'Show search Filters'}
                </span>
            </button>
            {filtersActive && (
                <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={this.clearAllFilters}
                    title="Clear all filter fields"
                    style={{ marginLeft: '10px' }}
                >
                    <i className="fa fa-times" aria-hidden="true" style={{ marginRight: '5px' }}></i>
                    Clear Filters
                </button>
            )}
        </div>
      </div>
    }

    return (
      <div className="s-slot-row">
        {pagination}
        <Table responsive={true} hover={true} className="s-grid-table-head">
          <tr>
            {this.props.columnConfig?.actions && (
              <th className="s-grid-title-cell s-grid-title-cell-small">
                  <div className="s-grid-title-empty"></div>
              </th>
            )}
            {this.renderSortableFilterableHeader(
              'emailConfig',
              this.getLocalizedLabel("table_header_emailConfig", "Email Config")
            )}
            {this.renderSortableFilterableHeader(
              'type',
              this.getLocalizedLabel("table_header_smtp_type", "Server Type")
            )}
            {this.renderSortableFilterableHeader(
              'host',
              this.getLocalizedLabel("table_header_host", "Server Host/IP")
            )}
            {this.renderSortableFilterableHeader(
              'folder',
              this.getLocalizedLabel("table_header_folder", "Folder")
            )}
            {this.renderSortableFilterableHeader(
              'port',
              this.getLocalizedLabel("table_header_port", "Server Port")
            )}
            {this.renderSortableFilterableHeader(
              'isDefault',
              this.getLocalizedLabel("table_header_isDefault", "Is Default")
            )}
          </tr>
        </Table>
        <div class="s-grid-slot-body">
          <DropZoneTable
            refresh={this.props.refresh}
            rows={rows}
            DocumentType={this.props.DocumentType}
            DocumentRef={this.props.DocumentRef}
          />
          {progress}
        </div>
      </div>
    );
  }
}

export default connect((state) => state)(SmtpConfigTable);
